import React, { Component } from 'react'
import LayoutWrapper from '../../component/LayoutWrapper/'
import './OrderDetails.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';
import Footer from '../../component/Footer/Footer';

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class OrderDetails extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    componentDidMount(){
        const orderDetailsData = this.props.location.state.orderData
        this.setState({
            product_details: orderDetailsData.product_details
        })
    }

    
    render() {
        
        return (
            // <div className="page-wrapper">
            <React.Fragment>
                <LayoutWrapper />
                <main className="main main-container">
                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/order-history">Order History</a></li>
                                <li className="breadcrumb-item"><Link to="#">Order Details</Link></li>                               
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                        
                    <div className="container">
                   
                        <div className="card-columns">
                        {
                            this.state.product_details && this.state.product_details.map((item,i)=>(
                                
                                    <div className="col-md-12 card" data-category="view" key={i}>
                                        {/* <div className="lib-panel"> */}
                                            <div className="row box-shadow">
                                                <div className="col-md-3">
                                                    <img className=" img-size" src={item.photo} alt="product"/>
                                                </div>
                                                <div className="col-md-9 p-4">
                                                    <div className="lib-row lib-header">
                                                        <h2 className="order-name">{item.name}</h2>
                                                        <div className="lib-header-seperator"></div>
                                                    </div>
                                                    <div className="lib-row lib-desc">
                                                        QTY : {item.qty} x <i className="fa fa-rupee-sign"></i>{item.price} 
                                                    </div>
                                                    <div className="lib-row lib-desc pt-2"> 
                                                        Price : <i className="fa fa-rupee-sign"></i>{item.sub_total}
                                                    </div>
                                                    {(item.color !== '' && item.size !== '' && item.sleeve !== '') &&
                                                    <span className="fnt-size">Color : {item.color}, Size: {item.size}, sleeve : {item.sleeve} </span>}
                                                </div>
                                            </div>
                                    </div>
                             
                           ))}
                            </div>
                
                
                        </div> 
                    
                </main>
                <div className="p-5"></div>
                <Footer />
            </React.Fragment>
            

        )
    }
}

OrderDetails.propTypes = {
    // doOrderHistoryListRes: PropTypes.any, 
};

const mapStateToProps = createStructuredSelector({
    // doOrderHistoryListRes: doOrderHistoryListRes,
});

function mapDispatchToProps(dispatch) {
    return {
        // historyOrderList: (data) => dispatch(historyOrderList(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(OrderDetails)
